import {_get} from "@api/services/httpService";
import {NEXTORE_URL} from "@api/services/nextore/index";

const NATURE_URL = '/natures';

export const getNatures = ()=> _get(`${NEXTORE_URL}${NATURE_URL}`);
